import React, { useEffect, useState } from "react";
import DeviceSignInScreen from "./DeviceSignInScreen";
import HomeScreen from "./HomeScreen";
import DisplayManager from "./ChatbotScreen/DisplayManager";
import SelectAgent from "./SelectAgent";
import { Agent } from "../model/Agent";
import { useDispatchKiosk } from "../redux";
import { agentSetAction } from "../redux/Actions";


const agent : Agent = {
  "idAgent": 811,
  "name": "CCI Show Room",
  "idAccount": 276,
  "capacity": "Digital employee",
  "description": "CCI Show Room",
  "agentImg": null,
  "dateCreated": new Date(),
  "agentPackage": "https://cdn.retorik.ai/spiritenginehtml5/characters/zahra",
  "urlAccess": "",
  "hostUrls": "*",
  "bddServer": null,
  "bddName": null,
  "bddLogin": null,
  "bddPassword": null,
  "hostIpAdress": "*",
  "hostDomain": "",
  "idHostingMode": 1,
  "agentImgType": null,
  "speechServicesToken": "f5f61ee8c7334f6ab967d007d970638b",
  "speechServicesRegion": "westeurope",
  "baseUri": "studio.retorik.ai/mejstjegx80had7vep/K2.ContentFields.WebChat",
  "agentIconUri": null,
  "agentLogoUri": null,
  "agentZone": { zone: [] },
  "tenant": "mejstjegx80had7vep",
  "keyAccess": "",
  "urlHosting": ""
}

const AppContainer = () => {
  const [visibility, setVisibility] = useState<"visible" | "hidden">("visible");


  const dispatch = useDispatchKiosk();

  useEffect(() => {
    dispatch(agentSetAction(agent));
    console.log("AppContainer mounted, agent set")
  }, [dispatch]);

  
  const handleVisibilityChange = (e) => {
    setVisibility(e.detail);
  }

  const handleVisibilityToggle = () => {
    setVisibility((current) => current === "visible" ? "hidden" : "visible");
  }

  useEffect(() => {
    document.addEventListener("retorikKioskSetVisibility", handleVisibilityChange);
    document.addEventListener("retorikKioskToggleVisibility", handleVisibilityToggle);

    return (): void => {
      document.removeEventListener("retorikKioskSetVisibility", handleVisibilityChange);
      document.removeEventListener("retorikKioskToggleVisibility", handleVisibilityToggle);
    }
  }, [])

  return (
    <div
      className="w-screen h-screen font-default"
      style={{
        visibility: visibility,
      }}
    >
      <DisplayManager/>
    </div>
  );
};

export default AppContainer;
